"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useNotifyDialog } from "../Providers/NotifyDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { notificationsDialogOpen, closeNotificationsDialog } =
    useNotifyDialog();

  return (
    <MuiDialog
      open={notificationsDialogOpen}
      onClose={closeNotificationsDialog}
    >
      {children}
    </MuiDialog>
  );
}
